import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { TokenStorageService } from './token.storage.service';
import {NavigationService} from './navigation-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private tokenStorageService: TokenStorageService,
    private navigationService: NavigationService
  ) {}

  canActivate(): boolean {
    if (!this.tokenStorageService.isTokenValid()) {
      this.tokenStorageService.logout();
      this.navigationService.redirectToLoginWithReturnUrl();
      return false;
    }
    return true;
  }
}
